import { ResponsiveGridLayouts } from "@ezmid/components-library";

export const defaultLayouts: ResponsiveGridLayouts = {
  lg: [
    {
      w: 24,
      h: 26,
      x: 0,
      y: 0,
      i: "count_users",
      moved: false,
      static: false,
    },
    {
      w: 24,
      h: 26,
      x: 24,
      y: 0,
      i: "count_payments",
      moved: false,
      static: false,
    },
    {
      w: 24,
      h: 26,
      x: 48,
      y: 0,
      i: "count_lecturers",
      moved: false,
      static: false,
    },
    {
      w: 24,
      h: 26,
      x: 72,
      y: 0,
      i: "count_courses",
      moved: false,
      static: false,
    },
    {
      w: 48,
      h: 54,
      x: 0,
      y: 26,
      i: "users_table",
      moved: false,
      static: false,
    },
    {
      w: 48,
      h: 54,
      x: 48,
      y: 26,
      i: "payments_table",
      moved: false,
      static: false,
    },
  ],
  md: [
    {
      w: 48,
      h: 26,
      x: 0,
      y: 0,
      i: "count_users",
      moved: false,
      static: false,
    },
    {
      w: 48,
      h: 26,
      x: 48,
      y: 0,
      i: "count_payments",
      moved: false,
      static: false,
    },
    {
      w: 48,
      h: 26,
      x: 0,
      y: 134,
      i: "count_lecturers",
      moved: false,
      static: false,
    },
    {
      w: 48,
      h: 26,
      x: 48,
      y: 134,
      i: "count_courses",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 54,
      x: 0,
      y: 26,
      i: "users_table",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 54,
      x: 0,
      y: 80,
      i: "payments_table",
      moved: false,
      static: false,
    },
  ],
  sm: [
    {
      w: 48,
      h: 26,
      x: 0,
      y: 0,
      i: "count_users",
      moved: false,
      static: false,
    },
    {
      w: 48,
      h: 26,
      x: 48,
      y: 0,
      i: "count_payments",
      moved: false,
      static: false,
    },
    {
      w: 48,
      h: 26,
      x: 0,
      y: 134,
      i: "count_lecturers",
      moved: false,
      static: false,
    },
    {
      w: 48,
      h: 26,
      x: 48,
      y: 134,
      i: "count_courses",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 54,
      x: 0,
      y: 26,
      i: "users_table",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 54,
      x: 0,
      y: 80,
      i: "payments_table",
      moved: false,
      static: false,
    },
  ],
  xs: [
    {
      w: 96,
      h: 26,
      x: 0,
      y: 0,
      i: "count_users",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 26,
      x: 0,
      y: 26,
      i: "count_payments",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 26,
      x: 0,
      y: 160,
      i: "count_lecturers",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 26,
      x: 0,
      y: 186,
      i: "count_courses",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 54,
      x: 0,
      y: 106,
      i: "users_table",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 54,
      x: 0,
      y: 52,
      i: "payments_table",
      moved: false,
      static: false,
    },
  ],
  xxs: [
    {
      w: 96,
      h: 26,
      x: 0,
      y: 0,
      i: "count_users",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 26,
      x: 0,
      y: 26,
      i: "count_payments",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 26,
      x: 0,
      y: 52,
      i: "count_lecturers",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 26,
      x: 0,
      y: 78,
      i: "count_courses",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 54,
      x: 0,
      y: 104,
      i: "users_table",
      moved: false,
      static: false,
    },
    {
      w: 96,
      h: 56,
      x: 0,
      y: 158,
      i: "payments_table",
      moved: false,
      static: false,
    },
  ],
};
